import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const fetchLicenseList = createAsyncThunk("fetchLicenseList", async ({ page, limit, filters }) => {
	const params = new URLSearchParams({
		page,
		size: limit,
		keyword: filters?.keyword ?? ""
	});

	const response = await axiosHttp.get(`assets/licenses?${params}`);
	const data = response.data?.data ?? response.data;

	const rawCards = data.countCards || [];
	const formattedCountCards = {
		totalLicenses: rawCards.find(c => c.name === "Total Licenses")?.value ?? 0,
		seatsInUse: rawCards.find(c => c.name === "Seats In Use")?.value ?? 0,
		expiringSoon: rawCards.find(c => c.name === "Expiring Soon")?.value ?? 0,
	};

	return {
		docs: data.content ?? data.docs ?? [],
		total: data.total ?? data.totalElements ?? 0,
		countCards: formattedCountCards
	};
});

export const fetchLicenseAssignments = createAsyncThunk("fetchLicenseAssignments", async ({ licenseId }) => {
	const response = await axiosHttp.get(`assets/licenses/${licenseId}/assignments`);
	return response.data?.data ?? response.data ?? [];
});

const LicenseListSlice = createSlice({
	name: "licenseListSlice",
	initialState: {
		isLoading: false,
		docs: [],
		countCards: { totalLicenses: 0, seatsInUse: 0, expiringSoon: 0 },
		page: 1,
		total: 0,
		assignments: [],
		assignmentsLoading: false,
		error: null
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchLicenseList.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(fetchLicenseList.fulfilled, (state, action) => {
				state.isLoading = false;
				state.docs = action.payload.docs;
				state.total = action.payload.total;
				state.countCards = action.payload.countCards;
			})
			.addCase(fetchLicenseList.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload;
			})

			.addCase(fetchLicenseAssignments.pending, (state) => {
				state.assignmentsLoading = true;
			})
			.addCase(fetchLicenseAssignments.fulfilled, (state, action) => {
				state.assignmentsLoading = false;
				state.assignments = action.payload;
			})
			.addCase(fetchLicenseAssignments.rejected, (state) => {
				state.assignmentsLoading = false;
			});
	},
});

export default LicenseListSlice.reducer;